import React from 'react';
import { services } from '../data/content';
import { ArrowRight } from 'lucide-react';

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-36 bg-[#2E2C28] text-[#EBE4DE]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-24">
          <div className="lg:col-span-4" data-reveal>
            <p className="sec-num text-sm tracking-[0.3em] uppercase" style={{color:'#D8AE94'}}>/ 03</p>
            <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#c9c0b3]">Core Services</p>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[60px] leading-[1.05] tracking-[-0.015em] font-light" data-reveal style={{ '--reveal-delay': '120ms' }}>
              Custom sales infrastructure built for <span className="italic" style={{color:'#D8AE94'}}>funded startups</span>.
            </h2>
            <p className="mt-8 text-lg text-[#c9c0b3] font-light max-w-2xl leading-relaxed" data-reveal style={{ '--reveal-delay': '240ms' }}>
              Transitioning from individual founder efforts to scalable revenue cycles.
            </p>
          </div>
        </div>

        <div className="divide-y divide-[#4a463f]">
          {services.map((s, i) => (
            <ServiceRow key={s.id} idx={i + 1} service={s} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceRow({ idx, service, delay }) {
  return (
    <div
      data-reveal
      style={{ '--reveal-delay': `${delay}ms` }}
      className="group grid grid-cols-1 lg:grid-cols-12 gap-6 py-10 lg:py-14 px-0 lg:px-4 -mx-0 lg:-mx-4 transition-all duration-300 hover:bg-[#33302b] hover:-translate-y-[2px]"
    >
      <div className="lg:col-span-1 font-serif italic text-2xl font-light" style={{color:'#D8AE94'}}>
        0{idx}
      </div>
      <div className="lg:col-span-4">
        <h3 className="font-serif text-2xl lg:text-3xl font-light leading-tight text-[#EBE4DE] group-hover:text-[#D8AE94] transition-colors duration-300">
          {service.name}
        </h3>
      </div>
      <div className="lg:col-span-6">
        <p className="text-base lg:text-lg leading-relaxed text-[#c9c0b3] font-light max-w-2xl">
          {service.body}
        </p>
      </div>
      <div className="lg:col-span-1 flex lg:justify-end items-start">
        <span className="inline-flex items-center justify-center w-10 h-10 border border-[#6b6459] rounded-full group-hover:border-[#D8AE94] group-hover:bg-[#D8AE94] transition-all duration-300">
          <ArrowRight size={16} className="text-[#c9c0b3] group-hover:text-[#2E2C28] transition-all duration-300 group-hover:translate-x-0.5" strokeWidth={1.5} />
        </span>
      </div>
    </div>
  );
}
